<template>
  <ul class="grid gap-3" role="radiogroup" aria-labelledby="radiogroup-label">
    <li v-for="(option, index) in options" :key="option.value" :id="`${name}-${index}`" tabindex="0" role="radio" :aria-checked="isChecked(option.value)" class="relative rounded-lg shadow-sm cursor-pointer group focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-indigo-500" @click="updateInput(option.value)">
      <div class="w-full h-full px-6 py-4 bg-white border border-gray-300 rounded-lg hover:border-gray-400 sm:flex sm:justify-between" :class="isChecked(option.value) ? 'bg-indigo-50' : 'bg-white'">
        <div class="flex items-center">
          <div class="text-sm">
            <p class="font-medium" :class="isChecked(option.value) ? 'text-indigo-900' : 'text-gray-900'" v-html="option.label"></p>
            <div :class="isChecked(option.value) ? 'text-indigo-700' : 'text-gray-500'" v-html="option.description"></div>
          </div>
        </div>
        <div class="flex mt-2 text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right" v-html="option.meta"></div>
      </div>
      <div class="absolute inset-0 border-2 rounded-lg pointer-events-none" :class="isChecked(option.value) ? 'border-indigo-500' : 'border-transparent'" aria-hidden="true"></div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'RadioGrid',

  props: {
    name: {
      type: String,
      default () {
        return (Math.random() * new Date().valueOf()).toString().substr(0, 6)
      }
    },

    value: {
      required: true
    },

    options: {
      type: Array
    }
  },

  methods: {
    isChecked (value) {
      return value == this.value
    },

    updateInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>